import { useDispatch } from 'react-redux';

import { NsCard } from 'components/common/ns-card/NsCard';
import NsContent from 'components/common/ns-content/NsContent';
import { AddressItem } from 'components/common/address-item/AddressItem';
import { FUEL_OPTIONS } from 'config/app-config';
import { capitalize } from 'utils/misc';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import {
  resetData,
  resetErrors
} from 'state/meterpoint-validation/meterpoint-validation-slice';

export const testId = 'addressCardTestId';

type AddressCardProps = {
  address?: object;
  fuelType?: typeof FUEL_OPTIONS[keyof typeof FUEL_OPTIONS];
  mpxn?: string;
  shouldShow?: boolean;
};

export const MeterCard = ({
  address,
  fuelType,
  mpxn,
  shouldShow
}: AddressCardProps) => {
  const dispatch = useDispatch();
  const capitalizedFuelType = capitalize(fuelType);
  const mpxnLabel = fuelType === FUEL_OPTIONS.ELECTRIC ? 'MPAN' : 'MPRN';

  const handleClick = () => {
    dispatch(resetData());
    dispatch(resetErrors());
  };

  if (!shouldShow) {
    return null;
  }

  return (
    <NsCard heading={capitalizedFuelType} testId={testId}>
      <NsContent>
        <p>
          <b>Address</b>
        </p>
        <AddressItem address={address} hasTitle={false} />
        <p>
          <strong>{mpxnLabel}</strong>
        </p>
        <p>{mpxn}</p>
        <NsSecondaryCta onClick={handleClick}>Edit</NsSecondaryCta>
      </NsContent>
    </NsCard>
  );
};
